// extracted by mini-css-extract-plugin
export var childrenWrapper = "QuickSearchModal-module--childrenWrapper--33ad6";
export var closeButton = "QuickSearchModal-module--closeButton--a4729";
export var hidden = "QuickSearchModal-module--hidden--c3026";
export var isOpen = "QuickSearchModal-module--isOpen--c8965";
export var quickSearch = "QuickSearchModal-module--quickSearch--a9e39";
export var searchBarWrapper = "QuickSearchModal-module--searchBarWrapper--033da";